import React, { createContext, useState, ReactNode } from 'react';

import { ItemScreenStatic } from 'types/ScreensStaticsProps';

interface ScreensStaticContextProps {
	screens: ItemScreenStatic[];
	setScreens: React.Dispatch<React.SetStateAction<ItemScreenStatic[]>>;
}

const ScreensStaticContext = createContext<ScreensStaticContextProps>({
	screens: [],
	setScreens: () => {}
});

interface ContextProps {
	children: ReactNode;
}

export function ScreensStaticProvider({ children }: ContextProps) {
	const [screens, setScreens] = useState<ItemScreenStatic[]>([]);

	return (
		<ScreensStaticContext.Provider value={{ screens, setScreens }}>
			{children}
		</ScreensStaticContext.Provider>
	);
}

export default ScreensStaticContext;
